/* ==================================================
#Search autocomplete
#Quick shop

Shopify.queryParams = {};
if (location.search.length) {
 for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
    aKeyValue = aCouples[i].split('=');
    if (aKeyValue.length > 1) {
     Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
    }
  }
}

/*============================================================================
  Search autocomplete
==============================================================================*/

var searchAutocomplete = {
  init: function(){

    var currentAjaxRequest = null;
    var shopURL = $('body').data('shop-url');
    var additionalPath = "";
    if(window.Nugnes.routes.root_url != "/"){
      additionalPath = window.Nugnes.routes.root_url;
    }
    var searchPath = shopURL + additionalPath + '/search?type=product&q='; //window.Nugnes.routes.root_url
    var collections_json = [];

    $.ajax({
      url: additionalPath + '/collections?view=json',
      async: true,
      success: function(data){
        collections_json = $.parseJSON(data);
      }
    });

    //Submit wildcard searches
    $(".search_form, .search__form, .header_search_form").on("submit", function(e){
      var formValue = $(this).find('input[name="q"]').val();
      if( !(formValue.slice(-1) == "*") ) 
        formValue = formValue + "*";
      var cleanFormValue = encodeURI(formValue);

      e.preventDefault();

      if(cleanFormValue == null) {
        window.location.href = additionalPath + '/search';
      } else {
        window.location.href = searchPath + cleanFormValue;
      }
    });

    var searchForms = $('form.search_form, form.search, form.header_search_form').each(function() {

      var input = $(this).find('input[name="q"]');
      var collections_label = 'Collezioni';
      var products_label = 'Prodotti';

      // Adding a list for showing search results.
      $('<div class="search__results-wrapper"><div class="search__results"><div class="search__results__container products"><strong>'+ products_label +'</strong><ul class="search__results__products"></ul></div><div class="search__results__container collections"><strong>'+ collections_label +'</strong><ul class="search__results__collections"></ul></div></div></div>').appendTo($(this));
      // Listening to keyup and change on the text field within these search forms.
      input.attr('autocomplete', 'off').bind('keyup', function(e) {
        if(input.val() == '') {
          $('.search__results__container').hide();
          $('.search__results__products').empty();
          $('.search__results__collections').empty();
        }

        var term = $(this).val();

        var cleanTerm = encodeURI(term);
        var form = $(this).closest('form');
        var searchURL =  searchPath + cleanTerm;

        form.find('.search__results__container').hide();
        var resultsListProducts = form.find('.search__results__products');
        var resultsListCollections = form.find('.search__results__collections');

        if (term.length >= 3) {
          if (currentAjaxRequest != null) currentAjaxRequest.abort();

          currentAjaxRequest = $.getJSON(searchURL +'*&view=json', function(data) {
            resultsListProducts.empty();
            resultsListCollections.empty();

            // If we have no results.
            if(data.results_count == 0) {
              var no_results_string = 'Spiacente, nessun risultato!';
              $('.search__results').append('<div class="search__results__container no-results"><span>' + no_results_string +'</span></div>');
              resultsListProducts.hide();
            } else {
              // If we have results.
              $.each(data.results, function(index, item) {
                if(index >= 8) {
                  return false;
                }

                var link = $('<a></a>').attr('href', item.url);

                //Collect collection handles if product
                if(item.object_type == 'product') {

                  var collectionHandles = [];
                  for(i=0; i < item.collections.length; i++) {
                    collectionHandles.push(item.collections[i].handle);
                  }

                  if(item.available == true) {

                    if(item.raw_compare > item.raw_price ) {
                      var itemPrice = '<span class="was_price">' + item.compare + '</span> ' + item.price;
                    } else {
                      if(item.price_varies && item.price_min > 0) {
                        var itemPrice = "da" + ' ' + item.price;
                      } else if(item.price > 0 || item.raw_price > 0) {
                        var itemPrice = item.price;
                      }
                    }
                  } else {
                    var itemPrice = "Sold Out";
                  }

                  if(item.thumbnail != 'NULL') {
                    link.append('<div class="image"><img class="lazyload transition--fade-in" src="' + item.thumbnail + '" /></div>');
                  }
                  link.append('<div class="info"><div class="title"><p class="name">' + item.title + '</p><p class="vendor">' + item.vendor + '</p></div><div class="item-pricing">'+ itemPrice +'</div></div></div>');
                }

                link.wrap('<li class="item-result result--' + item.object_type + '"></li>');
                resultsListProducts.append(link.parent());

                $('.search__results__container.products').show();
                resultsListProducts.show();
              });
              // The Ajax request will return at the most 5 results.
              // If there are more than 5, let's link to the search results page.
              if(data.results_count >= 8) {
                resultsListProducts.append('<li class="all-results"><span class="see-all"><a href="' + searchURL + '*">' + "Vedi tutti i risultati" + ' (' + data.results_count + ')</a></span></li>');
              }
            }

            var matchCollectionCount = 0;

            $.each(collections_json, function (index, item) {
                if ((item.title.toLowerCase().indexOf(term.toLowerCase()) >= 0) && (matchCollectionCount <= 5)){

                  var link_collection = $('<a></a>').attr('href', item.url);
                  link_collection.append('<div class="title">' + item.title + '</div>');
                  if(item.description != ''){
                    link_collection.append('<div class="description">' + item.description + '</div>');
                  }
                  link_collection.wrap('<li class="item-result result--collection"></li>');
                  resultsListCollections.append(link_collection.parent());
                  matchCollectionCount++;
                }
            });

            $('.hot-topic').hide();

            if(matchCollectionCount > 0 ){
              $('.search__results__container.collections').show();
              resultsListCollections.show();
            }

            $('.search__results-wrapper').show();
          });
        }
      });
    });
  },
  unload: function() {
    $('body').off('focus', '[data-autocomplete-true] input');
  }
}

/*============================================================================
  Quick shop
==============================================================================*/

var globalQuickShopProduct;

var quickShop = {
  init: function(){

    //EVENT - click on quick-shop
    $('body').on('click', '.js-quick-shop-link', function(e){
      e.preventDefault();

      var clickedElement = $(this);

      //Set productData object based on data attributes
      const productData = {
        handle: clickedElement.data('handle'),
        product_id: clickedElement.data('id'),
        single_variant: clickedElement.attr('data-single-variant'),
        product_url: clickedElement.data('url'),
        escaped_title: clickedElement.data('title'),
        full_description: clickedElement.data('full-description'),
        regular_description: clickedElement.data('regular-description'),
        image: clickedElement.data('image'),
        collection_handles: clickedElement.data('collection-handles').trim(',').split(','),
        materials: clickedElement.data('materials'),
        madein: clickedElement.data('madein'),
        money_format: $('body').data('money-format')
      };

      //Find current product and notify forms
      const $notifyForm = clickedElement.parent().next('.js-quickshop-forms__container').find('.notify_form');
      var productForm   = clickedElement.parent().next('.js-quickshop-forms__container').find('.product_form');
      var formContainer = clickedElement.parent().next('.js-quickshop-forms__container');

      $.fancybox.open($('.js-quick-shop'), {
        baseClass: 'quick-shop__lightbox product-' + productData.product_id,
        hash: false,
        infobar : false,
        toolbar: false,
        loop: true,
        smallBtn : true,
        mobile: {
          preventCaptionOverlap: false,
          toolbar: true,
          buttons: [
            "close"
          ]
        },
        beforeLoad: function(){
          quickShop.preRetrieveFormData(productForm, formContainer, productData);
          productForm = clickedElement.parent().next('.js-quickshop-forms__container').find('.product_form');
        },
        afterLoad: function(){
          quickShop.afterContent(productForm, $notifyForm, productData);
        },
        beforeClose: function(){
          quickShop.beforeClose(productData);
        }
      })

    });
  },

  preRetrieveFormData: function(productForm, formDataContainer, productData){
    if( !productForm.hasClass("viewed") ){
      $.ajax({
        dataType: "text text",
        async: false,
        cache: false,
        url: "/products/" + productData.handle + "?view=ajaxForm",
        success: function(response) {
            formDataContainer.empty();
            formDataContainer.append( $(response) );
        }
      });
    }
  },

  afterContent: function(productForm, $notifyForm, productData) {

    //Initiate selectCallback
    if(productForm.hasClass("product_form_options") && productForm.hasClass("viewed") == false) {
      //If form hasn't been viewed previously, run OptionSelectors function
      new Shopify.OptionSelectors(productForm.data("select-id"),
      {
        product: productForm.data("product"),
        onVariantSelected: selectCallback,
        enableHistoryState: productForm.data("enable-state")
      });
    }

    quickShop.retrieveProductInfo(productData);

    //Copy form data to modal
    $('.quick-shop__lightbox .js-notify-form').append($notifyForm);
    $('.quick-shop__lightbox .js-product-form').append(productForm);

    $('.js-quick-shop select[name="id"]').trigger('change');

    if ( $("#product_form_" + productData.product_id  + " .select-variant__link").length == 1 && !$("#product_form_" + productData.product_id  + " .select-variant__link").hasClass("select-variant__link--sold-out") ) {
     Nugnes.selectVariant( $("#product_form_" + productData.product_id  + " .select-variant__link"), $("#product_form_" + productData.product_id  + " .select-variant__hidden") );

     $("#product_form_" + productData.product_id  + " .js-add-to-cart").show()
     $("#product_form_" + productData.product_id  + " .js-select-variant").hide()
    }


  },

  beforeClose: function(productData) {

    const $insertedNotifyForm = $('.quick-shop__lightbox .notify_form');
    const $insertedProductForm = $('.quick-shop__lightbox .product_form');

    //Copy form data back to product loop and add .viewed
    $('.js-quickshop-forms--'+ productData.product_id).append($insertedProductForm);
    $('.js-quickshop-forms--'+ productData.product_id).append($insertedNotifyForm);
    $('.js-quickshop-forms--'+ productData.product_id +' .product_form').addClass('viewed');
    $('.js-quickshop-forms--'+ productData.product_id +' .notify_form').addClass('viewed');
    $('.js-quickshop-forms--'+ productData.product_id +' .js-add-to-cart').hide();
    $('.js-quickshop-forms--'+ productData.product_id +' .js-select-variant').show();

    selectToChange = $('.js-quickshop-forms--'+ productData.product_id +' .select-variant__hidden');

    selectToChange.find('option').each(function() {
        $(this).removeAttr('selected');
    });

    $('.js-quickshop-forms--'+ productData.product_id +' .select-variant__link').removeClass("select-variant__link--selected");

    const variantPrice = $('.js-current-price .money').text();
    $('.js-quick-shop-link[data-id=' + productData.product_id + ']').attr('data-initial-modal-price', variantPrice);
    $('.js-current-price, .js-was-price').empty();
  },

  retrieveProductInfo: function(productData){
    $.ajax({
      dataType: "json",
      async: false,
      cache: false,
      url: "/products/" + productData.handle + ".js",
      success: function(product){
        //Create new object combining info
        product = $.extend({}, product, productData);

        globalQuickShopProduct = product;
        quickShop.updateVariant(product.variants[0].id.toString(), product);
      }
    });
  },

  updateVariant: function(variant){
   if (globalQuickShopProduct != 'undefined'){

    let product = globalQuickShopProduct;

    $('.js-current-price').html('');
    $('.js-was-price').html('');
    $(".select-variant__links").removeClass("owl-carousel");

      //Title and Vendor
      $('.js-product-title').html('<a href="'+ product.product_url +'" title="'+ product.escaped_title +'">'+ product.title +'</a>');
      $('.js-product-vendor').html('<a href="/collections/vendors?q=' + product.vendor +'">' + product.vendor + '</a>');

      //Carryover star
      $('.js-carryover').html($('.product-card[data-product-id="' + product.id +'"]').find('.carryover').html());

      //Tag
      $('.js-product-tag').html($('.product-card[data-product-id="' + product.id +'"]').find('.labels').html());

      //Image
      $('.js-gallery-wrap').html('<a class="ratio-container" href="' + product.url + '"><img class="lazyload quick-shop__image" src="' + product.image +'" /></a>');

      //Product Description
      $('.js-full-description').html(product.full_description);
      $('.js-regular-description').html(product.regular_description);
      var productDetails = '<a href="'+ product.product_url +'" class="secondary_button" title="'+ product.escaped_title +' Details">'+ product.details_text +'</a>';
      $('.js-product-details').html(productDetails);

      //Product Materials
      if ( product.materials ) {
        $('.js-materials').html(product.materials);
      }

      if(!product.available){
        $(".js-select-variant").html("Sold Out");
      }
      else{
        $(".js-select-variant").html( "Seleziona la taglia" );
      }

      //Product Made in
      if(product.madein){
        $('.js-madein').html(product.madein);
      }

      if (product.single_variant == 'true'){

        //No variants

        //Sale
        if (product.compare_at_price > product.price) {
          $('.js-current-price').addClass('sale');
        } else {
          $('.js-current-price').removeClass('sale');
        }

        //Availability
        if (product.available == false){
          $('.js-sold-out').html("Sold Out");
        } else {
          $('.js-sold-out').html('');
        }

        //Price
        if (product.available == true) {
          $('.js-notify-form').hide();

          if (product.compare_at_price > product.price) {
            $('.js-was-price').html('<span class="money">' + Shopify.formatMoney(product.variants[0].compare_at_price, product.money_format)  + '</span>');
          }

          if (product.price == "Translation missing: it.collections.general.coming_soon"){
            $('.js-current-price').html("Translation missing: it.collections.general.coming_soon");
          } else if (product.price) {
            $('.js-current-price').html('<span class="money">' + Shopify.formatMoney(product.variants[0].price, product.money_format) + '</span>');
          } else {
            $('.js-current-price').html('Free');
          }
        }

      } else {

        //Variant loop
        for (var i = 0; i < product.variants.length; i++) {

          if (variant == product.variants[i].id.toString()){
            //Sale
            if (product.variants[i].compare_at_price > product.variants[i].price) {
              $('.js-current-price').addClass('sale');
            } else {
              $('.js-current-price').removeClass('sale');
            }

            //Price
            if (product.variants[i].available == true) {
              $('.js-notify-form').hide();

              if (product.variants[i].compare_at_price > product.variants[i].price) {
                $('.js-was-price').html('<span class="money">' + Shopify.formatMoney(product.variants[i].compare_at_price, product.money_format) + '</span>');
              }

              if (product.variants[i].price) {
                $('.js-current-price').html('<span class="money">' + Shopify.formatMoney(product.variants[i].price, product.money_format) + '</span>');
              }
            } else {
              $('.js-notify-form').show();
            }
          }
        }
      }
    }
  },
}
